export default __webpack_public_path__ + "static/media/s3.9c353d98.png";